"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _TableHead = _interopRequireDefault(require("./TableHead"));

var _TableBody = _interopRequireDefault(require("./TableBody"));

var _TableRow = _interopRequireDefault(require("./TableRow"));

var _TableCell = _interopRequireDefault(require("./TableCell"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var Table = function Table(_ref) {
  var className = _ref.className,
      striped = _ref.striped,
      firstColumnHeadings = _ref.firstColumnHeadings,
      horizontalBorders = _ref.horizontalBorders,
      largePadding = _ref.largePadding,
      children = _ref.children,
      props = _objectWithoutProperties(_ref, ["className", "striped", "firstColumnHeadings", "horizontalBorders", "largePadding", "children"]);

  var classNames = (0, _classnames.default)(className, 'table', {
    '-striped': striped,
    '-col-1-heading': firstColumnHeadings,
    '-horizontal-borders': horizontalBorders,
    '-large-padding': largePadding
  });
  return _react.default.createElement("table", _extends({
    className: classNames
  }, props), children);
};

Table.displayName = 'Table';
Table.propTypes = {
  /** Any classnames that you want to apply to the component */
  className: _propTypes.default.string,

  /** Apply the striped table styles */
  striped: _propTypes.default.bool,

  /** Set table headings to be down the first columns */
  firstColumnHeadings: _propTypes.default.bool,

  /** Apply horizontal borders */
  horizontalBorders: _propTypes.default.bool,

  /** Apply large padding */
  largePadding: _propTypes.default.bool,

  /** Contents of the Table */
  children: _propTypes.default.node
};
Table.defaultProps = {
  striped: false,
  firstColumnHeadings: false
};
Table.Head = _TableHead.default;
Table.Body = _TableBody.default;
Table.Row = _TableRow.default;
Table.Cell = _TableCell.default;
var _default = Table;
exports.default = _default;